import { TransformConvertorBase } from './transform.convertor';
import { SurrogateKeyTransformation } from 'app/model/dataflow/surrogatekeytransformation';
import { Transformation } from 'app/model/dataflow/transformation';
import { SchemaConvertor } from './schema.convertor';
import { SurrogateKeyPlainObject } from 'worker/app-workers/shared/plainObjects/surrogateKey.plainObject';
import { IResourceContext } from 'shell-models-lib';

export class SurrogateKeyConvertor extends TransformConvertorBase {
    private get surrogateKeyTransform(): SurrogateKeyTransformation {
        return this.transformation as SurrogateKeyTransformation;
    }

    private get surrogateKeyObject(): SurrogateKeyPlainObject {
        return this.transformObject as SurrogateKeyPlainObject;
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        await super.convert(contextData);
        this.surrogateKeyTransform.keyColumn = SchemaConvertor.convertColumnFromPlainObject(
            this.surrogateKeyObject.keyColumn,
            this.surrogateKeyTransform
        );

        if (this.surrogateKeyObject.configs.has('startAt')) {
            // eslint-disable-next-line radix
            this.surrogateKeyTransform.startAtValue = parseInt(this.surrogateKeyObject.configs.get('startAt'));
            this._handledConfigs.push('startAt');
        }
        if (this.surrogateKeyObject.configs.has('stepValue')) {
            // eslint-disable-next-line radix
            this.surrogateKeyTransform.stepValue = parseInt(this.surrogateKeyObject.configs.get('stepValue'));
            this._handledConfigs.push('stepValue');
        }
        if (this.surrogateKeyObject.configs.has('enableCdc')) {
            this.surrogateKeyTransform.enableCdc = this.surrogateKeyObject.configs.get('enableCdc') === 'true';
            this._handledConfigs.push('enableCdc');
        }

        super.postConvert();
        return this.transformation;
    }
}
